module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "industry"
  }, [_c('banner', {
    attrs: {
      "clazz": "industry-banner",
      "url": "Industry"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "industry-list"
  }, [_c('div', {
    staticClass: "w1200 tc"
  }, [_c('h1', {
    staticClass: "titleName"
  }, [_vm._v("选择您的行业，了解采购方案")]), _vm._v(" "), _c('div', {
    staticClass: "dib border-bottom"
  }), _vm._v(" "), _c('ul', {
    staticClass: "clearfix industry-ul"
  }, _vm._l((_vm.dataList), function(item, index) {
    return _c('li', [_c('a', {
      staticClass: "industry-w db",
      attrs: {
        "href": _vm.goDetail(item.name, item.id)
      }
    }, [_c('div', {
      staticClass: "dib industry-img"
    }, [_c('img', {
      directives: [{
        name: "lazy",
        rawName: "v-lazy",
        value: (_vm.$global.globalPath + item.src),
        expression: "$global.globalPath + item.src"
      }],
      attrs: {
        "alt": item.name
      }
    })]), _vm._v(" "), _c('h2', {
      staticClass: "title"
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('div', {
      staticClass: "tl desc"
    }, [_vm._v(_vm._s(item.content))]), _vm._v(" "), _vm._m(0, true)])])
  }), 0)])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "look-detail"
  }, [_c('span', [_vm._v("查看详情  >")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4ab2bc1e"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/solution/industry.vue
// module id = 694
// module chunks = 12